// Imports
import React, { Component } from "react";
import { Helmet } from "react-helmet";
import $ from "jquery";

// Components
import Header from "../../components/Header/Header";
import Banner from "../../components/Banner/Banner";
import Footer from "../../components/Footer/Footer";

// Assets
import timelineMobileAsset from "../../assets/about/timeline--mobile.svg";
import timelineWebAsset from "../../assets/about/timeline--web.svg";

import insight from "../../assets/svg/icn-insight.svg";
import execution from "../../assets/svg/icn-execute.svg";
import results from "../../assets/svg/icn-results.svg";

import peter from "../../assets/team-peter.jpg";
import tania from "../../assets/team-tania.jpg";
import kevin from "../../assets/team-kevin.jpg";
import john from "../../assets/team-john.jpg";
import renee from "../../assets/team-renee.jpg";
import rick from "../../assets/team-rick.jpg";
import len from "../../assets/team-len.jpg";
import todd from "../../assets/team-todd.jpg";
import suzie from "../../assets/team-suzie.jpg";
import erin from "../../assets/team-erin-sd.jpg";
import caroline from "../../assets/team-caroline.jpg";
import dustin from "../../assets/team-dustin.jpg";

class About extends Component {
  componentDidMount() {
    $(document).ready(function () {
      $(".toggle").click(function () {
        var member = $(this).data("bio");
        if ($(this).hasClass("open")) {
          $("#" + member).removeClass("openMember");
          $(this).removeClass("open");
        } else {
          $("#" + member).addClass("openMember");
          $(this).addClass("open");
        }
      });
    });
  }

  render() {
    return (
      <article id="company">
        <Helmet>
          <title>
            Company - Everything we do at aptihealth is centered around one thing: care.
          </title>
          <meta
            name="description"
            content="We&rsquo;re on a mission to revolutionize behavioral healthcare to ensure that the millions of people who need it have access to high-quality care, without delay. Join us!"
          />
          <meta property="og:url" content={window.location.href} />
        </Helmet>

        <Header />
        <Banner
          page="page-about"
          heading="A Transformative Approach to Behavioral Healthcare is Here"
        />

        <section className="p30">
          <div className="wrap">
            <div className="copy">
              <h3>
                Everything we do at aptihealth is centered around one thing: <strong>Care</strong>.
              </h3>
              <p>
                We&rsquo;re on a mission to revolutionize behavioral healthcare to ensure that the
                millions of people who need it have access to comprehensive care, without delay. We
                believe one&rsquo;s health shouldn&rsquo;t ever have to be compromised. We&rsquo;re
                driven by our company&rsquo;s three fundamental values:
              </p>
            </div>

            <div className="three-col values">
              <div className="col">
                <div>
                  <img src={insight} alt="Insight" />
                  <h3>Insight</h3>
                  <p>
                    We&rsquo;re an inspired team of innovative thinkers, relentless in our pursuit
                    of visionary ideas.
                  </p>
                </div>
              </div>
              <div className="col">
                <div>
                  <img src={execution} alt="Execution" />
                  <h3>Execution</h3>
                  <p>
                    We commit to turning ideas into actions that lead to fresh, groundbreaking
                    solutions.
                  </p>
                </div>
              </div>
              <div className="col">
                <div>
                  <img src={results} alt="Results" />
                  <h3>Results</h3>
                  <p>
                    We don&rsquo;t rest until our actions deliver breakthrough results – outcomes
                    that mean more for people.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="pt30 grey text-center">
          <div className="wrap">
            <h2>aptihealth Milestones</h2>

            <img src={timelineWebAsset} className="timeline desktop" alt="aptihealth Milestones" />

            <img
              src={timelineMobileAsset}
              className="timeline mobile"
              alt="aptihealth Milestones"
            />
          </div>
        </section>

        <section className="pt30">
          <div className="wrap">
            <h2 className="text-center">Leadership Team</h2>

            <div className="three-col team">
              <div className="col">
                <div id="rick" className="member">
                  <button className="toggle" data-bio="rick">
                    <span>Read Bio</span>
                  </button>
                  <div className="hold">
                    <img src={rick} alt="Rick Smith" />
                    <h3>
                      Rick Smith <span>CEO</span>
                    </h3>
                    <div className="bio">
                      <div>
                        <p>
                          A strategic, collaborative, solution focused leader with over twenty-five
                          years of Operations experience creating value and a successful record of
                          growth managing revenue in excess of $200 million annually across multiple
                          state markets. Ability to utilize financial, project management and
                          business development expertise to create impactful operating plans and
                          execute business unit initiatives. Experienced with a variety of
                          industries including primary physical health, behavioral health, human
                          services and juvenile justice while a promoting a culture of quality
                          services, Kaizen efficiencies and expanding stakeholder value with payors,
                          clients, staff and the communities we serve. Rick obtained his
                          undergraduate degree from Virginia Tech and his M.B.A from the Haslam
                          College of Business at the University of Tennessee in 2016.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col">
                <div id="dustin" className="member">
                  <button className="toggle" data-bio="dustin">
                    <span>Read Bio</span>
                  </button>
                  <div className="hold">
                    <img src={dustin} alt="Dustin Keller" />
                    <h3>
                      Dustin Keller, Ph.D <span>President, Chief Compliance and Operations Officer</span>
                    </h3>
                    <div className="bio">
                      <div>
                        <p>
                          Dustin is a seasoned mental health expert and executive leader with over
                          25 years of experience driving teams and operations forward. He has
                          dedicated his career to enhancing workplace culture, employee
                          satisfaction, and retention through innovative leadership development
                          programs and workplace wellbeing initiatives.
                        </p>

                        <p>
                          With a strong background in leadership and strategic development, Dustin
                          has spearheaded large-scale initiatives in foster care and behavioral
                          health services. In addition to serving as a lecturer in psychology at
                          Belmont University, he shares his expertise through regular consultations
                          and speaking engagements on leadership development, motivation, workplace
                          culture and wellbeing, mental health, and suicide prevention.
                        </p>

                        <p>
                          Dustin has held notable roles, including CEO of a multistate behavioral
                          health and foster care company, director of a state-level council to
                          improve mental health policy and lead on a multi-year, multi-million
                          dollar federal grant training project. In his private therapy practice, he
                          works with diverse clients, from children and families to couples and
                          older adults.
                        </p>

                        <p>
                          Dustin holds a Ph.D. in Psychology from Northcentral University and is a
                          Licensed Professional Counselor-Mental Health Service Provider (LPC-MHSP)
                          and National Certified Counselor (NCC). He is also certified as an expert
                          in traumatic stress by the American Academy of Experts in Traumatic
                          Stress. Committed to community service, Dustin has served on various
                          non-profit boards and volunteers for causes that advocate for the
                          advancement of others. He resides in Nashville, TN, with his wife and
                          eleven-year-old son.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col">
                <div id="len" className="member">
                  <button className="toggle" data-bio="len">
                    <span>Read Bio</span>
                  </button>
                  <div className="hold">
                    <img src={len} alt="Len Bolinsky" />
                    <h3>
                      Len Bolinsky <span>Vice President, Finance</span>
                    </h3>
                    <div className="bio">
                      <div>
                        <p>
                          Leonard S. Bolinsky is a seasoned executive with over 25 years of
                          experience leading complex finance and operations functions across
                          healthcare and human services organizations. Known for his analytical
                          rigor and operational insight, Len has held senior leadership roles
                          including Vice President of Operations, Regional Vice President, and
                          Corporate Division Controller, where he consistently drove financial
                          performance, operational efficiency, and strategic growth. Most recently,
                          Len served as Vice President of Operations at APIS Management Services,
                          overseeing service delivery for individuals with developmental
                          disabilities across a network of nonprofit organizations. Prior to that,
                          he spent over two decades at Pathways (formerly Providence Service
                          Corporation), progressing from Corporate Controller to Regional Vice
                          President, where he managed operations across ten states and the District
                          of Columbia. He also served as Interim CFO, playing a key role in M&A
                          activities, financial planning, and enterprise system conversions. Len
                          holds a Bachelor’s degree in Accounting from Lebanon Valley College. He is
                          widely respected for his expertise in revenue cycle management, financial
                          reporting, budgeting, and team leadership. His deep experience spans both
                          nonprofit and for-profit sectors, and he is recognized for his ability to
                          integrate finance and operations to deliver strong business outcomes.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col">
                <div id="renee" className="member">
                  <button className="toggle" data-bio="renee">
                    <span>Read Bio</span>
                  </button>
                  <div className="hold">
                    <img src={renee} alt="Reneé Abdou-Malta" />
                    <h3>
                      Reneé Abdou-Malta <span>Senior Vice President, New York Market </span>
                    </h3>
                    <div className="bio">
                      <div>
                        <p>
                          Ms. Renee Abdou-Malta is a healthcare executive with extensive experience
                          leading and directing a complex and diverse business market. Leveraging
                          industry experience in behavioral health and managed care to drive
                          systemic market strategies to optimize client satisfaction retention and
                          growth. Engagement of key stakeholders to effectively manage change and
                          achieve desired outcomes. A motivational leader that develops a high
                          performing culture through collaboration and shared accountability.
                        </p>
                        <p>
                          Ms. Abdou-Malta is currently the Senior Vice President, New York Market at
                          aptihealth, a virtual first, value-based care (VBC) behavioral health
                          solution that utilizes a unique care model with a multidisciplinary care
                          team approach. She was the former President of the New York Market for
                          Beacon Health Options and retired after 3 decades of service.
                        </p>
                        <p>
                          {" "}
                          A 39-year veteran of the health care industry, Ms. Abdou-Malta is an
                          active participant across the New York health care landscape. She is the
                          Chair of Women's Business Council of the Capital Region Chamber and serves
                          on the Board of Directors for the Northeast New York Chapter of the
                          American Red Cross and the Alzheimer's Association of Northeastern New
                          York. She is also the recipient of the 2021 Women Who Mean Business
                          Leadership Award by the Albany Business Review, the 2014 Women of
                          Excellence Award by The Women's Business Council and the Capital Region
                          Chamber of Commerce, the 2013 Outstanding Volunteer Award from the New
                          York Chapter of the Alzheimer's Association and the 2007 New York State
                          Senate's Woman of Distinction Award.
                        </p>
                        <p>
                          {" "}
                          A registered nurse, Ms. Abdou-Malta earned a Master of Science in nursing
                          from Syracuse University and a Bachelor of Science in nursing from Niagara
                          University. She is a Certified Case Manager and Certified Legal Nurse
                          Consultant.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col">
                <div id="kevin" className="member">
                  <button className="toggle" data-bio="kevin">
                    <span>Read Bio</span>
                  </button>
                  <div className="hold">
                    <img src={kevin} alt="Kevin Martin, MD" />
                    <h3>
                      Kevin Martin, MD <span>Chief Psychiatric Officer</span>
                    </h3>
                    <div className="bio">
                      <div>
                        <p>
                          Dr. Kevin Martin is the Chief Psychiatric Officer of aptihealth. He joined
                          aptihealth from Four Winds Saratoga psychiatric hospital where he served
                          as Chief Medical Officer. Prior to that he held senior leadership
                          positions in community mental health and child welfare.{" "}
                        </p>
                        <p>
                          Dr. Martin is board certified in general adult psychiatry and child and
                          adolescent psychiatry. A highly regarded clinical team leader, his 30
                          years of experience encompasses both adult and child/adolescent treatment
                          in private and public settings across multiple levels of care, including
                          outpatient, inpatient, residential, partial hospital, intensive
                          outpatient, as well as consultation in school and juvenile justice
                          settings.{" "}
                        </p>
                        <p>
                          In addition to his clinical work, he is a trainer and educator. He has
                          taught physicians-in-training in pediatrics, adult psychiatry, and
                          child/adolescent psychiatry, and presented to professional and lay
                          audiences.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col">
                <div id="erin" className="member">
                  <button className="toggle" data-bio="erin">
                    <span>Read Bio</span>
                  </button>
                  <div className="hold">
                    <img src={erin} alt="Erin Smokovich Dorflinger" />
                    <h3>
                      Erin Smokovich Dorflinger, LCSW-R{" "}
                      <span>Vice President of Clinical Services</span>
                    </h3>
                    <div className="bio">
                      <div>
                        <p>
                          Erin Smokovich Dorflinger, LCSW-R is the Vice President of Clinical
                          Services at aptihealth, where she leads the aptihealth medical group and
                          guides the delivery of compassionate, evidence-based, and
                          measurement-informed behavioral health care. With over 20 years of
                          experience as a licensed clinical social worker and behavioral health care
                          leader, Erin brings a deep understanding of what it takes to provide
                          high-quality care while empowering the teams who deliver it.
                        </p>
                        <p>
                          Before joining aptihealth, Erin served as Clinical Director at Four Winds
                          Hospitals, following her earlier role there as Director of Quality
                          Management. Her career spans a wide range of care settings including
                          inpatient psychiatry, partial hospitalization, intensive outpatient
                          programs, community mental health, and telehealth, giving her a
                          comprehensive view of behavioral health care across diverse treatment
                          settings.
                        </p>
                        <p>
                          Erin is passionate about building systems that support both clinical
                          excellence and meaningful patient experiences. Her areas of expertise
                          include evidence-based practice, regulatory compliance, workforce
                          development, quality improvement, and risk management. She has led
                          multidisciplinary teams, guided organizations through successful
                          accreditations, and implemented initiatives focused on delivering
                          outcomes-based care.
                        </p>
                        <p>
                          In addition to her leadership roles, Erin has maintained a strong
                          foundation in direct patient care and has provided behavioral health
                          consultation to organizations working to strengthen care models and foster
                          more inclusive, culturally responsive practices. She has also taught
                          graduate-level courses at the USC Suzanne Dworak-Peck School of Social
                          Work in areas such as diagnosis, crisis intervention, and group therapy.
                        </p>
                        <p>
                          Erin holds a Master of Social Work from the University of Southern
                          California and a Bachelor of Arts in Psychology from Saint Michael's
                          College.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col">
                <div id="caroline" className="member">
                  <button className="toggle" data-bio="caroline">
                    <span>Read Bio</span>
                  </button>
                  <div className="hold">
                    <img src={caroline} alt="Caroline Pickett" />
                    <h3>
                      Caroline Pickett <span>Senior Director Business Operations & Strategy</span>
                    </h3>
                    <div className="bio">
                      <div>
                        <p>
                          Caroline Pickett is the Senior Director of Operations & Strategy at
                          aptihealth, where she leads cross-functional initiatives that advance
                          operational performance and enhance both the patient and provider
                          experience. Since joining the company in 2020, she has played a key role
                          in aligning product, engineering, and clinical teams, helping launch
                          aptihealth’s proprietary care plan, support the expansion into value-based
                          care, and guide the organization through engineering and operational
                          transitions.
                        </p>
                        <p>
                          Caroline's work spans strategic planning and hands-on execution, with a
                          focus on aligning technology with business goals and optimizing internal
                          processes to support scalable growth. She began her career in the software
                          startup space, quickly advancing into leadership roles where she oversaw
                          customer onboarding, education, and enablement, while supporting strategic
                          initiatives across teams. Deeply passionate about behavioral health and
                          community impact, she also holds leadership roles with the American Cancer
                          Society and Albany Med Health System.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </div>

            <h2 className="text-center pt30">Board Members</h2>

            <div className="three-col team">
              <div className="col">
                <div id="john" className="member">
                  <button className="toggle" data-bio="john">
                    <span>Read Bio</span>
                  </button>
                  <div className="hold">
                    <img src={john} alt="John Chadwick" />
                    <h3>
                      John Chadwick <span>Chairman of the Board</span>
                    </h3>
                    <div className="bio">
                      <div>
                        <p>
                          John is a Founder and Managing Partner of Claritas Capital. John has over
                          thirty years of experience in financial services, with over twenty-five
                          years of experience in venture capital and private equity. John represents
                          Claritas Capital on the boards of directors for DecisionRx, FOH & BOH,
                          Forbes Travel Guide, Genomind, Esperta Health, PeopleOne Health,
                          Sharecare, StudioNow, Tankfarm, and TwelveStone Health Partners. He is a
                          board observer for Renewvia Energy and Cogitativo, and is a Senior Advisor
                          to 25m Health. John also serves on the board of directors of W. S. Farish
                          & Company, a private trust company. Previous work experience includes
                          Richland Ventures where John was a Partner and Chemical Bank, where he
                          served as a Vice President of the Energy Group. John graduated from the
                          University of Virginia with a B.A. in 1989, and graduated from The Wharton
                          School of the University of Pennsylvania with an M.B.A. in 1995.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col">
                <div id="peter" className="member">
                  <button className="toggle" data-bio="peter">
                    <span>Read Bio</span>
                  </button>
                  <div className="hold">
                    <img src={peter} alt="Peter Dorsman" />
                    <h3>
                      Peter Dorsman <span>Director</span>
                    </h3>
                    <div className="bio">
                      <div>
                        <p>
                          Peter is a public and private company director with extensive global
                          business experience. Functional expertise includes strategy, supply chain,
                          services, sales, marketing and continuous improvement.
                        </p>
                        <p>
                          Peter retired from NCR Corporation, a global technology company, in April
                          2014, During his tenure with NCR he served as executive vice president,
                          global services, executive vice president, global operations, Chief
                          Quality Officer and executive vice president, customer experience and
                          continuous improvement.
                        </p>
                        <p>
                          Peter currently serves on the board of directors for Applied Industrial
                          Technologies (NYSE:AIT) where he chairs the Executive Organization and
                          Compensation Committee and is a member of the Governance Committee, HD
                          Supply (NASDAQ:HDS) where he is Lead Independent Director and a member of
                          the Compensation and Governance Committees and IDEAL Industries where he
                          chairs the Compensation Committee and is a member of the Audit Committee.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col">
                <div id="tania" className="member">
                  <button className="toggle" data-bio="tania">
                    <span>Read Bio</span>
                  </button>
                  <div className="hold">
                    <img src={tania} alt="Tania Grant" />
                    <h3>
                      Tania Grant <span>Director</span>
                    </h3>
                    <div className="bio">
                      <div>
                        <p>
                          Tania is an established investor in both private and public market
                          markets, with years of investment, strategic and operational experience
                          across numerous industries. Tania has been able to successfully guide
                          private companies through growth, financing, restructuring and exits,
                          consistently creating value. Tania is dedicated to improving healthcare
                          and leads Claritas Capital's investing efforts within healthcare
                          technology and services companies. Tania is responsible for identifying
                          and evaluating investment opportunities, deal structuring and execution,
                          portfolio company strategy & monitoring and board representation. Tania
                          has a robust, high-quality deal flow pipeline and is highly connected in
                          the industry. Tania started her career on Wall Street in investment
                          banking. After IBK, Tania worked at long-short hedge funds investing in
                          public equities. She left Wall Street to invest in, and lead, two
                          businesses in which she later sold. Tania graduated with honors from
                          University of Virginia where she earned a Bachelor of Science (BS) in
                          finance from UVA's McIntire School of Commerce. As a former UVA Varsity
                          soccer player, she roots for all UVA sports. Tania is a native of Silver
                          Spring, Maryland.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col">
                <div id="todd" className="member">
                  <button className="toggle" data-bio="todd">
                    <span>Read Bio</span>
                  </button>
                  <div className="hold">
                    <img src={todd} alt="Todd Leri" />
                    <h3>
                      Todd Leri <span>Director</span>
                    </h3>
                    <div className="bio">
                      <div>
                        <p>
                          Todd Leri is an accomplished healthcare executive and private equity
                          operator with over two decades of experience driving innovation and growth
                          across the healthcare technology and value-based care landscape. He
                          currently serves as an Operating Partner at Eir Partners, a Miami-based
                          private equity firm focused exclusively on healthcare technology and
                          tech-enabled services. At Eir, Todd helps identify and scale
                          transformative businesses through operational leadership and thematic
                          investing. Before joining Eir, Todd was a founding executive and Chief
                          Growth Officer at CareBridge, the nation's leading value-based care
                          provider for members receiving home and community-based services (HCBS).
                          Under his leadership, CareBridge grew rapidly and was acquired by Elevance
                          Health for $2.7 billion in 2024. Previously, Todd was a founding executive
                          at Remedy Partners, where he served as Senior Vice President of Business
                          Development. Remedy pioneered bundled payment models and managed over $7
                          billion in healthcare spending before merging with Signify Health, which
                          was later acquired for $8 billion. Todd began his career in healthcare
                          restructuring at Alvarez & Marsal and as a financial analyst at the
                          University of Pennsylvania Health System. He holds both a BSE in
                          Electrical Engineering and an MSE in Systems Engineering from the
                          University of Pennsylvania.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col">
                <div id="suzie" className="member">
                  <button className="toggle" data-bio="suzie">
                    <span>Read Bio</span>
                  </button>
                  <div className="hold">
                    <img src={suzie} alt="Suzie Yoon" />
                    <h3>
                      Suzie Yoon <span>Director</span>
                    </h3>
                    <div className="bio">
                      <div>
                        <p>
                          Suzie Yoon is Managing Partner at Takeda Digital Ventures, where she leads digital health investments and strategic partnerships aligned with Takeda’s therapeutic priorities. She serves on multiple boards across the digital health ecosystem, including Oshi Health, BoulderCare, and EnsoData.
                        </p>
                        <p>Previously, she led the U.S. team at DNA Capital and began her career at Evercore in New York, focusing on healthcare services and technology. She holds a B.S. in Business Administration from Georgetown University.</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col">
                <div id="rick" className="member">
                  <button className="toggle" data-bio="rick">
                    <span>Read Bio</span>
                  </button>
                  <div className="hold">
                    <img src={rick} alt="Rick Smith" />
                    <h3>
                      Rick Smith <span>Director</span>
                    </h3>
                    <div className="bio">
                      <div>
                        <p>
                          A strategic, collaborative, solution focused leader with over twenty-five
                          years of Operations experience creating value and a successful record of
                          growth managing revenue in excess of $200 million annually across multiple
                          state markets. Ability to utilize financial, project management and
                          business development expertise to create impactful operating plans and
                          execute business unit initiatives. Experienced with a variety of
                          industries including primary physical health, behavioral health, human
                          services and juvenile justice while a promoting a culture of quality
                          services, Kaizen efficiencies and expanding stakeholder value with payors,
                          clients, staff and the communities we serve. Rick obtained his
                          undergraduate degree from Virginia Tech and his M.B.A from the Haslam
                          College of Business at the University of Tennessee in 2016.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <Footer />
      </article>
    );
  }
}

export default About;
